export const numberFormat = {
  NATIONAL: 'NATIONAL',
  INTERNATIONAL: 'INTERNATIONAL',
  RFC3966: 'RFC3966',
};
